<script>
  export default {
    data() {
      return {
        options: {},

        json: {
          living_hs_heating_system: 'zentral',
          living_hs_heating_system_spec_etage: '1980',
          living_hs_heating_system_spec_central: '1980',

          living_hs_heating_system_warmwater: 'zentral',
          living_hs_heating_system_warmwater_zentral_extras: [],
          living_hs_heating_system_warmwater_spec_decentral: 'heizoel',

          living_hs_avg_room_temp: 18,
          living_hs_airing_habits: 'viele',
          living_hs_insulating_standard: ['dach'],
          living_hs_warm_water_consumption: 'duschen',
          living_hs_saving_fittings: 'keine',
        },
      }
    },

    props: ['hideCallback'],

    mounted() {
      this.options = this.co2Service.getOptions();
    },

    methods: {
      show(jsonString) {
        if(jsonString) {
          try {
            this.json = JSON.parse(jsonString);
          } catch(e) {
            console.error(e)
          }
        }
        this.$refs.estModal.show();
      },
      submitCode() {
        this.hideCallback(JSON.stringify(this.json));
        this.$refs.estModal.hide()
      }
    }

  }

</script>
<style scoped lang="scss"></style>
<template>
  <div class="est-modal">

    <b-modal size="lg" ref="estModal" hide-footer lazy
             no-close-on-backdrop hide-header-close
             no-close-on-esc title="Monatsverbrauch schätzen">


      <b-row>
        <b-col sm="6">

          <h5 class="mb-3 text-secondary">
            <font-awesome-icon class="fa-fw mr-1" icon="temperature-high"/>
            Angaben zur Gebäudeheizung
          </h5>

          <b-form-group id="group-living_hs_heating_system" label="Heizungssystem:"
                        label-for="radio-living_hs_heating_system">
            <b-form-radio-group
              id="radio-living_hs_heating_system"
              v-model="json.living_hs_heating_system"
              :options="options.living_hs_heating_system"
              name="radio-living_hs_heating_system"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <transition name="fade">
            <b-form-group v-if="json.living_hs_heating_system === 'etage'"
                          id="group-living_hs_heating_system_spec_etage" label="Etagenheizung:"
                          label-for="radio-living_hs_heating_system_spec_etage">
              <b-form-radio-group
                id="radio-living_hs_heating_system_spec_etage"
                v-model="json.living_hs_heating_system_spec_etage"
                :options="options.living_hs_heating_system_spec"
                name="radio-living_hs_heating_system_spec_etage"
                stacked
              ></b-form-radio-group>
            </b-form-group>
          </transition>

          <transition name="fade">
            <b-form-group v-if="json.living_hs_heating_system === 'zentral'"
                          id="group-living_hs_heating_system_spec_central" label="Heizungssystem zentral:"
                          label-for="radio-living_hs_heating_system_spec_central">
              <b-form-radio-group
                id="radio-living_hs_heating_system_spec_central"
                v-model="json.living_hs_heating_system_spec_central"
                :options="options.living_hs_heating_system_spec"
                name="radio-living_hs_heating_system_spec_central"
                stacked
              ></b-form-radio-group>
            </b-form-group>
          </transition>

        </b-col>
        <b-col sm="6">

          <h5 class="mb-3 text-secondary">
            <font-awesome-icon class="fa-fw mr-1" icon="shower"/>
            Angaben zur Warmwasserbereitung
          </h5>

          <b-form-group id="group-living_hs_heating_system_warmwater" label="Warmwasserbereitung:"
                        label-for="radio-living_hs_heating_system_warmwater">
            <b-form-radio-group
              id="radio-living_hs_heating_system_warmwater"
              v-model="json.living_hs_heating_system_warmwater"
              :options="options.living_hs_heating_system_warmwater"
              name="radio-living_hs_heating_system_warmwater"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <transition name="fade">
            <b-form-group v-if="json.living_hs_heating_system_warmwater === 'zentral'"
                          id="group-living_hs_heating_system_warmwater_zentral_extras" label="Art:"
                          label-for="radio-living_hs_heating_system_warmwater_zentral_extras">
              <b-form-checkbox-group
                id="input-living_hs_heating_system_warmwater_zentral_extras"
                v-model="json.living_hs_heating_system_warmwater_zentral_extras"
                :options="options.living_hs_heating_system_warmwater_zentral_extras"
                name="input-living_hs_heating_system_warmwater_zentral_extras"
                living_hs_insulating_standard
              ></b-form-checkbox-group>
            </b-form-group>
          </transition>

          <transition name="fade">
            <b-form-group v-if="json.living_hs_heating_system_warmwater === 'dezentral'"
                          id="group-living_hs_heating_system_warmwater_spec_decentral" label="Energieträger Warmwasserbereitung:"
                          label-for="radio-living_hs_heating_system_warmwater_spec_decentral">
              <b-form-radio-group
                id="radio-living_hs_heating_system_warmwater_spec_decentral"
                v-model="json.living_hs_heating_system_warmwater_spec_decentral"
                :options="options.living_hs_heating_system_warmwater_spec_decentral"
                name="radio-living_hs_heating_system_warmwater_spec_decentral"
                stacked
              ></b-form-radio-group>
            </b-form-group>
          </transition>



        </b-col>
      </b-row>

      <hr>

      <h5 class="mb-3 text-secondary">
        <font-awesome-icon class="fa-fw mr-1" icon="door-open"/>
        Weitere Angaben
      </h5>

      <b-row>
        <b-col sm="6">

          <b-form-group id="group-living_hs_avg_room_temp" label="Durchschnittliche Raumtemperatur:"
                        label-for="input-living_hs_avg_room_temp">
            <b-form-select
              id="input-living_hs_avg_room_temp"
              v-model="json.living_hs_avg_room_temp"
              :options="options.living_hs_avg_room_temp"
              size="sm"
              required
            ></b-form-select>
          </b-form-group>

          <b-form-group id="group-living_hs_airing_habits" label="Lüftgewohnheiten:"
                        label-for="radio-living_hs_airing_habits">
            <b-form-radio-group
              id="radio-living_hs_airing_habits"
              v-model="json.living_hs_airing_habits"
              :options="options.living_hs_airing_habits"
              name="radio-living_hs_airing_habits"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <b-form-group id="group-living_hs_insulating_standard" label="Nachträgliche Modernisierung:"
                        label-for="radio-living_hs_insulating_standard">
            <b-form-checkbox-group
              id="input-living_hs_insulating_standard"
              v-model="json.living_hs_insulating_standard"
              :options="options.living_hs_insulating_standard"
              name="input-living_hs_insulating_standard"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>

        </b-col>
        <b-col sm="6">

          <b-form-group id="group-living_hs_warm_water_consumption" label="Persönlicher Warmwasserverbrauch:"
                        label-for="radio-living_hs_warm_water_consumption">
            <b-form-radio-group
              id="radio-living_hs_warm_water_consumption"
              v-model="json.living_hs_warm_water_consumption"
              :options="options.living_hs_warm_water_consumption"
              name="radio-living_hs_warm_water_consumption"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <b-form-group id="group-living_hs_saving_fittings" label="Wasserspararmaturen:"
                        label-for="radio-living_hs_saving_fittings">
            <b-form-radio-group
              id="radio-living_hs_saving_fittings"
              v-model="json.living_hs_saving_fittings"
              :options="options.living_hs_saving_fittings"
              name="radio-living_hs_saving_fittings"
              stacked
            ></b-form-radio-group>
          </b-form-group>

        </b-col>
      </b-row>

      <hr>

      <div class="float-right">
        <b-button class="mr-2" size="sm" rounded variant="warning" @click="$refs.estModal.hide()">
          <font-awesome-icon class="fa-fw mr-1" icon="times"></font-awesome-icon>
          <span>Bearbeitung abbrechen</span>
        </b-button>
        <b-button size="sm" rounded variant="success" @click="submitCode()">
          <font-awesome-icon class="fa-fw mr-1" icon="save"></font-awesome-icon>
          <span>Angaben übernehmen</span>
        </b-button>
      </div>

    </b-modal>

  </div>
</template>
